export default "__VITE_ASSET__19aae0ae__"